import { Card, Form, Input, Select, Button, DatePicker, message } from "antd";
import { supabase } from "../supabaseClient";
import bgImage from "../assets/bg-1.jpg";
import { useLoading } from "../contexts/LoadingContext";

const { Option } = Select;

export default function StudentPage({ requests, setRequests }) {
    const { setLoading } = useLoading();
    const onFinish = async (values) => {
        setLoading(true);
        const { error } = await supabase
            .from("don_tham_quan_nhan")
            .insert([
                {
                    ten_quan_nhan: values.soldierName,
                    don_vi: values.unit,
                    ten_nguoi_than: values.visitorName,
                    quan_he: values.relation,
                    ngay_tham: values.visitDate.format("YYYY-MM-DD"),
                    so_dien_thoai: values.phone,
                    email_nhan_ket_qua: values.email,
                },
            ]);

        if (error) {
            message.error("Gửi đăng ký thất bại");
            console.error(error);
        } else {
            message.success("Đăng ký thành công");
        }
        setLoading(false);
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                padding: "40px 16px",
            }}
        >
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Card
                    style={{
                        width: 520,
                        background: "rgba(255, 247, 204, 0.95)",
                        border: "3px solid #1f5f3b",
                    }}
                >
                    {/* Tiêu đề */}
                    <div style={{ textAlign: "center", marginBottom: 20 }}>
                        <h1 style={{ color: "#0b3d2e", marginBottom: 4 }}>
                             TRƯỜNG QUÂN SỰ QUÂN KHU 7
                        </h1>
                        <h2 style={{ color: "#54ad93", marginBottom: 4 }}>
                            ĐĂNG KÝ ĐƠN THĂM QUÂN NHÂN
                        </h2>
                        <p style={{ fontSize: 12 }}>
                            Vui lòng điền đầy đủ thông tin theo mẫu sau
                        </p>
                    </div>

                    <Form layout="vertical" onFinish={onFinish}>
                        <Form.Item
                            label={<b style={{ color: "red" }}>TÊN QUÂN NHÂN</b>}
                            name="soldierName"
                            rules={[{ required: true, message: "Vui lòng nhập tên quân nhân" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>ĐƠN VỊ</b>}
                            name="unit"
                            rules={[{ required: true, message: "Vui lòng nhập đơn vị" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>TÊN NGƯỜI THÂN</b>}
                            name="visitorName"
                            rules={[{ required: true, message: "Vui lòng nhập tên người thân" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>QUAN HỆ</b>}
                            name="relation"
                            rules={[{ required: true, message: "Vui lòng chọn quan hệ với quân nhân" }]}
                        >
                            <Select>
                                <Option value="Cha">Cha</Option>
                                <Option value="Mẹ">Mẹ</Option>
                                <Option value="Vợ">Vợ</Option>
                                <Option value="Chồng">Chồng</Option>
                                <Option value="Anh/Chị/Em">Anh / Chị / Em</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>NGÀY THĂM</b>}
                            name="visitDate"
                            rules={[{ required: true, message: "Vui lòng chọn ngày thăm" }]}
                        >
                            <DatePicker
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                placeholder="Chọn ngày thăm"
                                disabledDate={(current) =>
                                    current && current < new Date().setHours(0, 0, 0, 0)
                                }
                            />
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>SỐ ĐIỆN THOẠI</b>}
                            name="phone"
                            rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label={<b style={{ color: "red" }}>EMAIL NHẬN KẾT QUẢ</b>}
                            name="email"
                            rules={[
                                { required: true, message: "Vui lòng nhập email" },
                                { type: "email", message: "Email không hợp lệ" },
                            ]}
                        >
                            <Input placeholder="vd: abc@gmail.com" />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            style={{
                                marginTop: 10,
                                height: 45,
                                fontWeight: "bold",
                                background: "#1f5f3b",
                            }}
                        >
                            GỬI ĐĂNG KÝ
                        </Button>
                    </Form>
                </Card>
            </div>
        </div>
    );
}
